<template>
  <div class="dashboard-container">
    <!-- 子路由出口：首页的子页面将在这里显示 -->
    <router-view></router-view>
  </div>
</template>

<script setup>
// 首页容器，主要用于承载子页面
</script>

<style scoped>
.dashboard-container {
  height: 100%;
  padding: 0;
  margin: 0;
}
</style>